import { h } from "preact";
import { useSelector } from "react-redux";

import { classNames } from "../helpers";
import { selectCurrentUser } from "../store";

import Avatar from "./Avatar.jsx";
import Button from "./Button.jsx";
import UserPositionAndCountry from "./UserPositionAndCountry.jsx";

export default function ProfileLink({ bordered }) {
  const user = useSelector(selectCurrentUser);

  if (!user) {
    return <div></div>;
  }

  return (
    <div
      class={classNames("profile-link", bordered && "profile-link--bordered")}
    >
      <div class="profile-link__wrap">
        <div class="profile-link__avatar">
          <Avatar user={user} plain big />
        </div>
        <div class="profile-link__content">
          <h1 class="t-h4 t-h4--margin-small pt-0">{user.name}</h1>
          <UserPositionAndCountry user={user} class="mb-32" />
        </div>
      </div>
      <div>
        <Button class="profile-link__button" secondary to="/profile">
          Visit profile
        </Button>
      </div>
      {bordered && <div class="profile-link__border"></div>}
    </div>
  );
}
